const getAllRolesResponse = (response) => {
  return response?.roles.map((role) => {
    return {
      value: role?.id,
      label: `${role?.name}`,
      isHost: role?.isHost,
      isOperator: role?.isOperator,
    };
  });
};

export default getAllRolesResponse;
